import PropTypes from "prop-types";
import React from "react";
import _ from "underscore";
import { AccordionSectionType } from "../types/components/Accordion";

type TAccordionProps = {
    sections: AccordionSectionType[];
    initialSection?: number[];
    onContentChange?: (active: number[]) => void;
};

type TAccordionState = {
    active: number[];
};

class Accordion extends React.Component<TAccordionProps, TAccordionState> {
    static propTypes = {
        sections: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                content: PropTypes.element,
            })
        ).isRequired,
        onContentChange: PropTypes.func,
        initialSection: PropTypes.arrayOf(PropTypes.number),
    };

    constructor(props) {
        super(props);
        this.state = {
            active: this.props.initialSection ? this.props.initialSection : [0],
        };
    }

    setActive = (id) => {
        if (this.isActive(id)) {
            this.setState({ active: this.state.active.filter((index) => index !== id) });
            return;
        }

        this.setState({ active: [id].concat(this.state.active) });
        return;
    };

    isActive = (index) => _.contains(this.state.active, index);

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(this.props.initialSection, prevProps.initialSection)) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                active: this.props.initialSection ? this.props.initialSection : [0],
            });
        }
        if (this.props.onContentChange && !_.isEqual(this.state.active, prevState.active)) {
            this.props.onContentChange(this.state.active);
        }
    }

    render() {
        const classes = {
            accordion: true,
        };

        const numSections = this.props.sections.length;

        return (
            <div className={_.classSet(classes)}>
                {this.props.sections.map(function (this: Accordion, section, index) {
                    const activeClass = this.isActive(index) ? "active" : "inactive";
                    let order = "";
                    if (numSections > 1) {
                        if (index === 0) {
                            order = "first";
                        } else if (index === numSections - 1) {
                            order = "last";
                        } else {
                            order = "middle";
                        }
                    }
                    const marker = section.isMarked ? (
                        <span className={"membershipExceptionIndicatorDark"} />
                    ) : null;
                    return (
                        <div key={index} className={`${activeClass} ${order} aSection`}>
                            <h3 onClick={this.setActive.bind(this, index)}>
                                {section.title} {marker}
                            </h3>
                            <div className="accordionSection">
                                {!section.lazy || this.isActive(index) ? section.content : null}
                            </div>
                        </div>
                    );
                }, this)}
            </div>
        );
    }
}

export default Accordion;
